import { CommonMessages } from '../common.messages';

export const PanelOrdersEditMessages = {
    GetOrderFailed: {
        key: 'GetOrderFailed',
        message: 'Error while communication with the server. Unable to get details about the Order.'
    },
    OrderNotFound: {
        key: 'OrderNotFound',
        message: 'Error while communication with the server. Unable to find details about the Order.'
    },
    GetOrderStatusTriggersFailed: {
        key: 'GetOrderStatusTriggersFailed',
        message: 'Error while communication with the server. Unable to get Order status transition triggers.'
    },
    UpdateStatusFailed: {
        key: 'UpdateStatusFailed',
        message: 'Error while server request. Unable to change Order status.'
    },
    UpdateStatusToCancelledRejected: {
        key: 'UpdateStatusToCancelledRejected',
        message: 'Additional permissions are required for Orders cancellation.'
    },
    UpdateStatusSucceeded: {
        key: 'UpdateStatusSucceeded',
        message: 'Order status is successfully updated.'
    },
    UpdateAmountSucceeded: {
        key: 'UpdateAmountSucceeded',
        message: 'Order amount is successfully updated.'
    },
    UpdateAmountFailed: {
        key: 'UpdateAmountFailed',
        message: 'Error while server request. Unable to change Order amount.'
    },
    ...CommonMessages
};
